import { Box, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
    formatStockQuantity,
    getOtherCompanyStockEntries,
} from "../../../shared/utils/companyStockUtils";

export default function OtherCompanyStockChips({
    companyActualQty,
    currentCompany,
    compact = false,
}) {
    const { t } = useTranslation();
    const entries = getOtherCompanyStockEntries(
        companyActualQty,
        currentCompany
    );

    if (entries.length === 0) return null;

    return (
        <Box
            sx={
                compact
                    ? { display: "contents" }
                    : {
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 0.5,
                          mt: 0.75,
                      }
            }
        >
            {entries.map(({ company, quantity }) => {
                const isOutOfStock = quantity <= 0;
                const quantityLabel = formatStockQuantity(quantity);
                const label = `${company}: ${quantityLabel} ${t(
                    "retailPos.qty"
                )}`;

                return (
                    <Chip
                        key={company}
                        size="small"
                        label={label}
                        title={label}
                        variant="outlined"
                        sx={{
                            height: compact ? 24 : 22,
                            maxWidth: "100%",
                            fontSize: compact ? "0.75rem" : "0.7rem",
                            fontWeight: 700,
                            color: isOutOfStock ? "#d32f2f" : "#1565c0",
                            borderColor: isOutOfStock
                                ? "rgba(211, 47, 47, 0.28)"
                                : "rgba(21, 101, 192, 0.28)",
                            backgroundColor: isOutOfStock
                                ? "rgba(211, 47, 47, 0.06)"
                                : "rgba(21, 101, 192, 0.06)",
                            "& .MuiChip-label": {
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            },
                        }}
                    />
                );
            })}
        </Box>
    );
}
